import compact from "lodash/compact";
import debounce from "lodash/debounce";
import flatMap from "lodash/flatMap";
import { INode } from "yfiles";
import getGraphNodeSources from "../nodeOrEdgeSourceDataHandling/getGraphNodeSources";
export default (documentId, graphReadyRef, onChangeGraphModel, debounceWait, updateNodesSourceDocumentObjectId, skipOnReady) => {
    var _a;
    let readyForListener = !(Boolean((_a = graphReadyRef.current) === null || _a === void 0 ? void 0 : _a.readyForListeners) || skipOnReady);
    return debounce((sender, evt) => {
        var _a;
        if (!((_a = graphReadyRef.current) === null || _a === void 0 ? void 0 : _a.readyForListeners))
            return;
        if (!readyForListener) {
            readyForListener = true;
            return;
        }
        if (evt.item instanceof INode) {
            const currentNodesSource = compact(flatMap(sender.nodes.toArray(), getGraphNodeSources));
            onChangeGraphModel(documentId, { nodesSource: currentNodesSource, onlyDiffSources: false }, updateNodesSourceDocumentObjectId);
        }
    }, debounceWait);
};
